import type { ResolutionLevel } from '../../../types';
import { ResolutionLevelBlock } from '../../base';

const ResolutionLevelRenderer = (level: ResolutionLevel) => <ResolutionLevelBlock level={level} />;

export default ResolutionLevelRenderer;
